import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Spinner,
  Input,
  Label,
  Row,
  Col,
  FormGroup,
} from "reactstrap";
import { getMenu, updateMenuItem } from "../actions/menuActions";
import { getCategories } from "../actions/productActions";
import { makeTitle } from "./utils/conversion";

const MenuView = () => {
  const dispatch = useDispatch();
  const [categoryId, setCategoryId] = useState("");
  const { categories: menuCategories, loading, error, updatingId } = useSelector(
    (state) => state.menuList
  );
  const { categories } = useSelector((state) => state.categoriesList);

  useEffect(() => {
    dispatch(getCategories());
  }, [dispatch]);

  const categoryList = Array.isArray(categories?.data)
    ? categories.data
    : Array.isArray(categories)
      ? categories
      : [];

  useEffect(() => {
    if (categoryId) dispatch(getMenu(categoryId));
  }, [dispatch, categoryId]);

  useEffect(() => {
    if (categoryList.length > 0 && !categoryId) {
      setCategoryId(String(categoryList[0].id));
    }
  }, [categoryList.length, categoryId]);

  const handleToggle = (product) => {
    dispatch(updateMenuItem(product));
  };

  const getProductKey = (product) => {
    const p = product.id ?? product.product ?? product.product_id;
    const v = product.product_variant ?? product.variant_id ?? "";
    return `${p}-${v}`;
  };

  const hasAnyProducts = (cats) =>
    (cats || []).some(
      (c) => Array.isArray(c.sub_categories) && c.sub_categories.some(
        (s) => Array.isArray(s.products) && s.products.length > 0
      )
    );

  return (
    <>
      <div className="content">
        <Row>
          <Col xs="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Menu (Ajna)</CardTitle>
                <p className="category">
                  Enable or disable products per sub-category.
                </p>
              </CardHeader>
              <CardBody>
                <FormGroup className="mb-3">
                  <Label for="menu-category">Category</Label>
                  <Input
                    id="menu-category"
                    type="select"
                    value={categoryId}
                    onChange={(e) => setCategoryId(e.target.value)}
                  >
                    {categoryList.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {makeTitle(cat.name || cat.title || `Category ${cat.id}`)}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}
                {loading ? (
                  <div className="d-flex align-items-center justify-content-center py-5">
                    <Spinner color="secondary" />
                  </div>
                ) : !hasAnyProducts(menuCategories) ? (
                  <span className="text-muted">
                    No categories or products. Select a category or ensure the menu API returns data.
                  </span>
                ) : (
                  <div className="menu-nested">
                    {(menuCategories || []).map((category) => (
                      <div key={category.id} className="mb-4">
                        <h5 className="text-dark mb-3">
                          {makeTitle(category.name || `Category ${category.id}`)}
                        </h5>
                        {(category.sub_categories || []).map((sub) => (
                          <div key={sub.id} className="mb-3 pl-3">
                            <h6 className="text-dark font-weight-bold mb-2">
                              {makeTitle(sub.name || `Sub-category ${sub.id}`)}
                            </h6>
                            <ul className="list-unstyled">
                              {(sub.products || []).map((product) => {
                                const productKey = getProductKey(product);
                                const displayName =
                                  product.name ||
                                  product.title ||
                                  product.product_name ||
                                  `Product ${product.id ?? product.product_id}`;
                                const isActive =
                                  product.is_active !== undefined
                                    ? product.is_active !== false
                                    : Array.isArray(product.store_product_price) &&
                                      product.store_product_price.length > 0
                                    ? product.store_product_price[0].is_active !== false
                                    : true;
                                return (
                                  <li
                                    key={productKey}
                                    className="d-flex align-items-center py-2 border-bottom"
                                  >
                                    <span className="flex-grow-1">
                                      {makeTitle(displayName)}
                                    </span>
                                    <button
                                      type="button"
                                      className={`menu-pill-toggle ${isActive ? "on" : "off"}`}
                                      onClick={() => handleToggle(product)}
                                      disabled={updatingId === productKey}
                                    >
                                      {isActive ? "On" : "Off"}
                                    </button>
                                    {updatingId === productKey && (
                                      <Spinner size="sm" color="secondary" className="ml-2" />
                                    )}
                                  </li>
                                );
                              })}
                            </ul>
                            {(!sub.products || sub.products.length === 0) && (
                              <span className="text-muted small">No products</span>
                            )}
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default MenuView;
